<script lang="ts">
	import SvelteMarkdown from './Markdown';
	import CodeSpan from '../../markdown/CodeSpan.svelte';
	import TextRender from '../../markdown/TextRender.svelte';
	import ListItemRender from '../../markdown/ListItem.svelte';
	import { getContext } from 'svelte';
	import { appStore} from '../../../stores/appStore';

	export let content: string;
	export let systemMessage: boolean = false;
	export let isNewMessage: boolean = false;
	const messageId: string = getContext('messageId');
</script>

{#key content}
	<SvelteMarkdown
		source={
			isNewMessage && !systemMessage
	      ? $appStore.animatedMessagesData[messageId].message
	      : content.replace(/ {3}/g, "")
	  }
		renderers={{
			codespan: CodeSpan,
			text: TextRender,
      listitem: ListItemRender
		}}
	/>
{/key}

<style lang="scss">
	:global(p) {
		white-space: pre-line;
	}
</style>
